function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PopupData from './popup/Popup.context';
import PopupName from './popup/PopupName.react';
import PopupDetails from './popup/PopupDetails.react';
import PopupFiles from './popup/PopupFiles.react';
import PopupParagraph from './popup/PopupParagraph.react';
import RichTextEditor from 'react-rte';

// TODO :: Stop if app / type is not in constants
// TODO :: make call with pageID to get latest article
var Popup = function Popup() {
  var _useParams = useParams(),
    popupID = _useParams.popupID;
  var cmsPopups = useSelector(function (s) {
    return s.cms.popups || {};
  });
  var _useState = useState({
      popup: {},
      popupID: null,
      app: '',
      name: '',
      title: '',
      subtitle: '',
      type: '',
      published: {},
      paragraph: RichTextEditor.createEmptyValue(),
      files: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    var popup = Object.values(cmsPopups).find(function (x) {
      return x._id === popupID;
    });
    if (popup) {
      var _popup$paragraph;
      var publishedObj = {};
      popup.published.forEach(function (x) {
        if (x.isPublished) publishedObj[x.clientEnv] = true;
      });
      setState({
        popup: popup,
        popupID: popup._id,
        app: popup.clientApp,
        title: popup.title,
        name: (popup === null || popup === void 0 ? void 0 : popup.name) || '',
        subtitle: popup.subtitle,
        type: popup.type,
        published: publishedObj,
        paragraph: ((_popup$paragraph = popup.paragraph) === null || _popup$paragraph === void 0 ? void 0 : _popup$paragraph.length) > 0 ? RichTextEditor.createEmptyValue().setContentFromString(popup.paragraph, 'html') : RichTextEditor.createEmptyValue(),
        files: popup.files
      });
    }
  }, [popupID, cmsPopups]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement(PopupData.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement(PopupName, null), /*#__PURE__*/React.createElement(PopupDetails, null), /*#__PURE__*/React.createElement(PopupFiles, null), /*#__PURE__*/React.createElement(PopupParagraph, null))));
};
export default Popup;